import { takeLatest, put, all } from 'redux-saga/effects';
import {
  GET_TRANSACTIONS_SUCCESS,
  GET_TRANSACTIONS,
  GET_DETAIL,
  GET_DETAIL_SUCCESS,
  SET_LOADING,
  REQUEST_ERROR,
  GET_REFERENCE_DATA,
  GET_REFERENCE_DATA_SUCCESS,
} from '../types/transaction';

import {
  requestTransactionsApi,
  requestTransactionDetailApi,
  requestStatusApi,
} from '../requests/transaction';

import { onFailRequest } from '../../utils';

/**
 * Get reference data
 * @param {*} payload
 */
function* requestReferenceData(payload) {
  try {
    const [orderStatusData] = yield all([requestStatusApi({})]);
    yield put({
      type: GET_REFERENCE_DATA_SUCCESS,
      data: {
        orderStatus: orderStatusData.data,
      },
    });
  } catch (error) {
    yield onFailRequest({
      payload,
      error,
    });
  }
}

/**
 * Get transactions with pagination
 * @param {*} payload
 */
function* requestTransactions(payload) {
  try {
    const response = yield requestTransactionsApi(payload);
    yield requestReferenceData(payload);
    yield put({
      type: GET_TRANSACTIONS_SUCCESS,
      data: response,
    });
  } catch (error) {
    yield onFailRequest({
      payload,
      error,
      *onCallback() {
        yield put({ type: REQUEST_ERROR });
      },
    });
  }
}

/**
 * Get detail data transaction
 * @param {*} payload
 */
function* requestTransactionDetail(payload) {
  try {
    const { params } = payload;
    const { data } = yield requestTransactionDetailApi(params);
    yield put({
      type: GET_DETAIL_SUCCESS,
      data,
    });
  } catch (error) {
    yield onFailRequest({
      payload,
      error,
      *onCallback() {
        yield put({ type: SET_LOADING, isLoading: false });
      },
    });
  }
}

export default [
  takeLatest(GET_TRANSACTIONS, requestTransactions),
  takeLatest(GET_DETAIL, requestTransactionDetail),
  takeLatest(GET_REFERENCE_DATA, requestReferenceData),
];
